import React from 'react'
import './MOEPagenation.scss'
const MOEPagenation = ({ perPage, total, handlePageClick, currentPage }) => {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(total / perPage); i++) {
        pageNumbers.push(i);
    }

    return (
        <nav className='moe-pagination' aria-label='Page navigation'>
            <ul className='pagination justify-content-center gap-1'>
                {
                    pageNumbers.map(number => (
                        <li key={number} className={'page-item'}>
                            <button
                                type='button'
                                onClick={handlePageClick} className={'page-link ' + (currentPage == number ? ' active' : '')}>
                                {number}
                            </button>
                        </li>
                    ))
                }
            </ul>
        </nav>
    )
}


export default MOEPagenation